import { render, staticRenderFns } from "./EditSettingsModal.vue?vue&type=template&id=21ff3acb&scoped=true"
import script from "./EditSettingsModal.vue?vue&type=script&lang=js"
export * from "./EditSettingsModal.vue?vue&type=script&lang=js"
import style0 from "./EditSettingsModal.vue?vue&type=style&index=0&id=21ff3acb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ff3acb",
  null
  
)

export default component.exports